// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const versionInfo = {
    "dirty": false,
    "raw": "b38b459",
    "hash": "b38b459",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "b38b459",
    "semverString": null,
    "version": "2.2504.0008"
};
/* tslint:enable */
